import { useState, useEffect } from "react";
import { FiMenu, FiX } from "react-icons/fi";

/** Default section registry — can be overridden via the `sections` prop. */
export const defaultSections = [
  { id: "overview", label: "Overview" },
  { id: "outreach", label: "International Outreach" },
  { id: "events", label: "Events" },
  { id: "tenders", label: "Tenders" },
  { id: "dossiers", label: "Country Dossiers" },
  { id: "reports", label: "Commercial Reports" },
];

// Backwards-compatible alias
export const sections = defaultSections;

export default function SwitchNav({ sections: items = defaultSections }) {
  const [active, setActive] = useState(items[0]?.id);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      },
      { rootMargin: "-20% 0px -60% 0px", threshold: 0.1 }
    );
    items.forEach((s) => {
      const el = document.getElementById(s.id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, [items]);

  return (
    <nav
      id="switch-nav"
      className="sticky top-0 z-50 bg-[#FAF7F2]/90 backdrop-blur-xl border-y border-[#FEF7F4] shadow-lg shadow-black/[0.02]"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-10">
        <div className="flex h-16 items-center justify-between gap-3">
          
          {/* Pills */}
          <div className="hidden md:flex items-center gap-2 overflow-x-auto no-scrollbar">
            {items.map((s) => (
              <a
                key={s.id}
                href={`#${s.id}`}
                onClick={() => setActive(s.id)}
                className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-all duration-300 border ${
                  active === s.id
                    ? "bg-[#DA2128] text-white border-[#DA2128] shadow-lg shadow-[#DA2128]/25"
                    : "bg-white text-[#4a4a5a] border-[#FEF7F4] hover:border-[#DA2128]/30 hover:text-[#DA2128]"
                }`}
              >
                {s.label}
              </a>
            ))}
          </div>

          {/* Mobile toggle */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden h-10 w-10 rounded-xl bg-white border border-[#FEF7F4] text-[#1a1a2e] flex items-center justify-center shadow-sm hover:border-[#DA2128]/30 transition-colors"
            aria-label="Menu"
          >
            {mobileOpen ? <FiX className="h-5 w-5" /> : <FiMenu className="h-5 w-5" />}
          </button>
        </div>

        {/* Mobile menu */}
        {mobileOpen && (
          <div className="md:hidden pb-5 pt-2 flex flex-wrap gap-2 border-t border-[#FEF7F4]/60">
            {items.map((s) => (
              <a
                key={s.id}
                href={`#${s.id}`}
                onClick={() => {
                  setActive(s.id);
                  setMobileOpen(false);
                }}
                className={`rounded-full px-4 py-2 text-sm font-medium transition-all border ${
                  active === s.id
                    ? "bg-[#DA2128] text-white border-[#DA2128] shadow-md"
                    : "bg-white text-[#4a4a5a] border-[#FEF7F4]"
                }`}
              >
                {s.label}
              </a>
            ))}
          </div>
        )}
      </div>
    </nav>
  );
}
